<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ form.id ? "Editar Curso Idioma" : "Crear Curso Idioma" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- <v-flex md12>
				<v-text-field
					label="Descripción"
					v-model="form.descripcion"
					:rules="$validate(['required'])"
					required
					maxlength="200"
				></v-text-field>
			</v-flex> -->

              <v-flex md6>
                <v-autocomplete
                  v-model="form.id_idioma"
                  :items="idiomas"
                  item-text="nombre_idioma"
                  :item-value="val => parseInt(val.id)"
                  label="Idioma"
                  :rules="$validate(['required'])"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6>
                  <v-radio-group
                  label="Certificado"
                    v-model="form.certificado"
                    :rules="[
                      v => {
                        if (v == null) {
                          return 'El campo es obligatorio.';
                        }
                        return true;
                      }
                    ]"
                  >
                    <v-radio label="Si" :value="true"></v-radio>
                    <v-radio label="No" :value="false"> </v-radio>
                  </v-radio-group>
              </v-flex>
              <v-flex md12>
                <v-autocomplete
                  v-model="form.id_institucion"
                  :items="instituciones"
                  item-text="nombre_institucion"
                  :item-value="val => parseInt(val.id)"
                  label="Institución Académica"
                  :rules="$validate(['required'])"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  label="Calificación"
                  v-model.number="form.calificacion"
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      if (v < 0) return 'El campo no puede ser negativo.';
                      if (v > 100)
                        return 'No puede ingresar un número tan grande.';
                      return true;
                    }
                  ]"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  label="Duracion en horas"
                  v-model.number="form.duracion_horas"
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      if (v < 0) return 'El campo no puede ser negativo.';
                      if (v > 100000000)
                        return 'No puede ingresar un número tan grande.';
                      return true;
                    }
                  ]"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  label="Año"
                  v-model.number="form.gestion"
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      if (v < 0) return 'El campo no puede ser negativo.';
                      if (v > 10000000000)
                        return 'No puede ingresar un número tan grande.';
                      return true;
                    }
                  ]"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                <label class="select-date-title">Nivel:</label>
              </v-flex>
              <v-layout wrap>
                <v-flex xs12> Lectura </v-flex>
                <v-layout row>
                  <v-radio-group
                    v-model="form.id_parametro_lectura"
                    row
                    :rules="[
                      v => {
                        if (v == null) return 'El campo es obligatorio.';
                        return true;
                      }
                    ]"
                  >
                    <v-flex xs4>
                      <v-radio label="Básico" :value="37"></v-radio>
                    </v-flex>
                    <v-flex xs4>
                      <v-radio label="Intermedio" :value="38"></v-radio>
                    </v-flex>
                    <v-flex xs4>
                      <v-radio label="Avanzado" :value="39"></v-radio>
                    </v-flex>
                  </v-radio-group>
                </v-layout>
                <v-flex xs12> Expresión oral </v-flex>
                <v-layout row>
                  <v-radio-group
                    v-model="form.id_parametro_expresion"
                    row
                    :rules="[
                      v => {
                        if (v == null) return 'El campo es obligatorio.';
                        return true;
                      }
                    ]"
                  >
                    <v-flex xs4>
                      <v-radio label="Básico" :value="37"></v-radio>
                    </v-flex>
                    <v-flex xs4>
                      <v-radio label="Intermedio" :value="38"></v-radio>
                    </v-flex>
                    <v-flex xs4>
                      <v-radio label="Avanzado" :value="39"></v-radio>
                    </v-flex>
                  </v-radio-group>
                </v-layout>
                <v-flex xs12> Escritura </v-flex>
                <v-layout row>
                  <v-radio-group
                    v-model="form.id_parametro_escritura"
                    row
                    :rules="[
                      v => {
                        if (v == null) return 'El campo es obligatorio.';
                        return true;
                      }
                    ]"
                  >
                    <v-flex xs4>
                      <v-radio label="Básico" :value="37"></v-radio>
                    </v-flex>
                    <v-flex xs4>
                      <v-radio label="Intermedio" :value="38"></v-radio>
                    </v-flex>
                    <v-flex xs4>
                      <v-radio label="Avanzado" :value="39"></v-radio>
                    </v-flex>
                  </v-radio-group>
                </v-layout>
              </v-layout>
              <v-flex md12>
                <input
                  id="input"
                  type="file"
                  @change="handleFileUpload()"
                  ref="file"
                  accept="image/*, application/pdf"
                  value="reset"
                />
                <p class="red--text body-1" v-if="error">
                  {{ mensjageerror }}
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      error: false,
      cargado: false,
      mensjageerror: "",
      file: "",
      instituciones: [],
      lecturas: [],
      expresiones: [],
      escrituras: [],
      idiomas: []
    };
  },
  mounted() {
    this.obtenerIdiomas();
    this.obtenerLectura();
    this.obtenerExpresion();
    this.obtenerEscrituras();
    this.obtenerInstituciones();
    this.$bus.$on("openDialogCrearActualizarCursoIdioma", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.file = null;
      this.cargado = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
      handleFileUpload() {
      if (this.$refs.file.value !== "") {
        this.cargado = true;
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 2048999) {
          this.error = true;
          this.mensjageerror = "El archivo excede el tamaño permitido de 2MB.";
        } 
        else if (this.$refs.file.value === "") {
          this.error = true;
          this.mensjageerror = "Archivo invalido.";
        } else if (!(
          this.$refs.file.files[0].type.includes("application/pdf") ||
          this.$refs.file.files[0].type.includes("image/"))) {
          this.error = true;
          this.mensjageerror = "Formato no admitido por el sistema";
        } 
        else {
          this.error = false;
          this.mensjageerror = "";
        }
        this.file = file;
      }
    },
    async save() {
      if (this.error) {
        return this.error;
      }
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          delete this.form.idioma;
          delete this.form.institucion;
          delete this.form.parametro_lectura;
          delete this.form.parametro_expresion;
          delete this.form.parametro_escritura;
          if (this.cargado) {
            let formData = new FormData();
            formData.append("file", this.file);
            let res = await this.$http.post(
              process.env.API_URL + "public/upload",
              formData
            );
            this.form.url_documento = res.data;
          }
          if (this.form.id) {
            const id = this.form.id;
            delete this.form.id;
            delete this.form._user_created;
            delete this.form._user_updated;
            delete this.form._created_at;
            delete this.form._updated_at;
            await this.$service.graphql({
              query: `
								mutation edit($id: ID!, $curso_idioma: EditCursoIdioma!){
									cursoIdiomaEdit(id: $id, curso_idioma: $curso_idioma){
										id
									}
								}
							`,
              variables: {
                id: id,
                curso_idioma: this.form
              }
            });
          } else {
            let user = this.$storage.get("user");
            if (this.$route.params.id) {
              this.form.id_persona = parseInt(this.$route.params.id);
            } else {
              this.form.id_persona = user.id_persona;
            }
            if (!this.cargado) {
              this.error = true;
              this.mensjageerror = "Debe seleccionar un archivo.";
              this.loading = false;
              return false;
            } else {
              this.error = false;
              this.mensjageerror = "";
            }
            this.form.id_estado = 1;
            await this.$service.graphql({
              query: `
								mutation add($curso_idioma: NewCursoIdioma!){
									cursoIdiomaAdd(curso_idioma: $curso_idioma){
										id
									}
								}
							`,
              variables: {
                curso_idioma: this.form
              }
            });
          }
        } catch (error) {
          console.log(e);
        }
        document.getElementById("input").value = "";
        this.$message.success();
        this.loading = false;
        this.close();
      }
    },
    async obtenerInstituciones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              institucions{
                rows{
                  id
                  nombre_institucion
                }
              }
            }`
        });
        this.instituciones = respuesta.institucions.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerEscrituras() {
      try {
        let res = await this.$service.graphql({
          query: `
						 query{
            params(tipo:"escritura"){
              rows{
                id
                valor
              }
            }
          }
					`
        });
        this.escrituras = res.params.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerExpresion() {
      try {
        let res = await this.$service.graphql({
          query: `
						 query{
            params(tipo:"expresion"){
              rows{
                id
                valor
              }
            }
          }
					`
        });
        this.expresiones = res.params.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerLectura() {
      try {
        let res = await this.$service.graphql({
          query: `
						 query{
            params(tipo:"lectura"){
              rows{
                id
                valor
              }
            }
          }
					`
        });
        this.lecturas = res.params.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerIdiomas() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
              idiomas{
                rows{
                  id
                  nombre_idioma
                }
              }
          }
					`
        });
        this.idiomas = res.idiomas.rows;
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/CrearActualizarIdiomas.vue